import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const FiscalYearService = {
  // Get all fiscal years
  getList: async () => {
    try {
      const response = await instance.get("/accounting/fiscal-years", {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching fiscal years:", error);
      throw error;
    }
  },

  // Get a single fiscal year by code
  getByCode: async (code) => {
    try {
      const response = await instance.get(`/accounting/fiscal-years/${code}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching fiscal year ${code}:`, error);
      throw error;
    }
  },

  // Create a new fiscal year
  create: async (data) => {
    try {
      const response = await instance.post("/accounting/fiscal-years", data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating fiscal year:", error);
      throw error;
    }
  },

  // Update an existing fiscal year
  update: async (code, data) => {
    try {
      const response = await instance.put(`/accounting/fiscal-years/${code}`, data, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating fiscal year ${code}:`, error);
      throw error;
    }
  },

  // Delete a fiscal year
  delete: async (code) => {
    try {
      const response = await instance.delete(`/accounting/fiscal-years/${code}`, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting fiscal year ${code}:`, error);
      throw error;
    }
  },

  // Activate a fiscal year
  activate: async (code) => {
    try {
      const response = await instance.patch(`/accounting/fiscal-years/${code}/activate`, {}, {
        headers: {
          Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error activating fiscal year ${code}:`, error);
      throw error;
    }
  },
};

export default FiscalYearService;
